import { Component, OnInit } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { UserService } from 'app/services/user/user.service';
import { Router } from '@angular/router'
import { ToastService } from 'app/services/toast-wrapper/toast-wrapper.service';
import { analyticsTrack } from 'app/services/auth/analytics.service';

@Component({
  selector: 'tcg-dash',
  templateUrl: './tcg-dash.component.html',
  styleUrls: ['./tcg-dash.component.scss']
})
export class TcgDashComponent implements OnInit{
  filters = [{name:"all", category:"all", selected:true, total:144, collected:0},{name:"kryptomons", category:"kmon", selected:false, total:56, collected:0},{name:"spells", category:"spells", selected:false, total:81, collected:0},{name:"items", category:"items", selected:false, total:6, collected:0},{name:"Mystery", category:"nft", selected:false, total:1, collected:0}];
  wallet:string;
  cards
  bigCard = {back:true, id:null}
  cardUuidCode:string;
  pipeFilter: string;
  missingCards;
  showModal = false;
  rewardImg = './assets/img/Icon/secret-egg.svg'
  hasFreeSpin:boolean;
  constructor(public http: HttpClient, private userService: UserService, private router: Router, public toastService: ToastService){

  }

  ngOnInit(){
    this.wallet = this.userService._userInfoData.recordedWallet;
    let post = {walletId:this.wallet}
    this.http.post("https://api.kryptomon.co/tcg/getRedeemedCards.php", post).subscribe((item:any)=>{
     this.cards = item;
     console.log(item)
      for(let i = 0; i<this.filters.length;i++){
        this.filters[i].collected = this.cards.filter(x => x.type === this.filters[i].category).length;
        console.log(this.cards.filter(x => x.type === this.filters[i].category).length)
      }
      this.filters[0].collected = this.filters[1].collected + this.filters[2].collected + this.filters[3].collected
      this.checkSpin();
      this.selectFilter(0)
    })
  }

  highlightCard(c){
    this.bigCard.back = false;
    this.bigCard.id = c.cardId
  }
  flipBack(){
    this.bigCard.back = true;
    this.bigCard.id = null
  }

  redeemCard(){
    let post= {uuid: this.cardUuidCode, walletId:this.wallet}
    this.http.post("https://api.kryptomon.co/tcg/redeemCard.php", post).subscribe((item:any)=>{
      this.cards = item.data;
      console.log(item)
      for(let i = 0; i<this.filters.length;i++){
        this.filters[i].collected = this.cards.filter(x => x.type === this.filters[i].category).length;
        console.log(this.cards.filter(x => x.type === this.filters[i].category).length)
      }
      this.filters[0].collected = this.filters[1].collected + this.filters[2].collected + this.filters[3].collected;
      this.bigCard.back = false;
      this.bigCard.id = item.cardId

      analyticsTrack("Claimed KMON Card",{
        type:item.cardType
      })

      console.log(item.cardId.toLowerCase().indexOf('m'))

      if(item.cardId.toLowerCase().indexOf('m')==0){
        this.showModal = true;
      }
      this.checkSpin();
    }, (error)=>{
      this.toastService.genericError();
    })
  }

  checkSpin(){
    let post = {
      walletId: this.wallet
    }
    this.http.post("https://api.kryptomon.co/tcg/checkSpin.php", post).subscribe((response:any)=>{
      console.log(response)
      if(response.hasFreeSpin){
        this.hasFreeSpin = true;
      }else{
        this.hasFreeSpin = false
      }
    }, (error)=>{
      this.toastService.genericError();
    })
  }

  selectFilter(index){
    for(let i = 0; i<this.filters.length;i++){
      if(i == index){
        this.filters[i].selected = true;
        if(this.filters[i].category=="all"){
          this.pipeFilter = ''
          var countItems = this.cards.length;
        }else{
          this.pipeFilter = this.filters[i].category
          var countItems = this.cards.filter(x => x.type === this.filters[i].category).length;
        }
        
        this.missingCards = Array(this.filters[i].total - countItems).fill(0).map((x,i)=>i);
      }else{
        this.filters[i].selected = false;
      }
    }
  }

  openCollection(){
    this.router.navigate(["/hunters/claim"])
  }

  gotoSpin(){
    this.router.navigate(["/spin-the-wheel"])
  }

}
